<template>
  <v-container fluid class="pa-5">
    <v-overlay :value="isLoading" absolute>
      <div class="d-flex flex-column align-center justify-center">
        <v-progress-circular indeterminate size="64" :width="5" />
        <span class="my-4">กำลังโหลดข้อมูล</span>
      </div>
    </v-overlay>

    <template v-if="!isLoading">
      <v-card class="card-container pa-6" elevation="0">
        <v-card-title class="px-0">
          <span class="title-text">จัดการแพ็คค่าคอมมิชชั่นการแนะนำสมาชิก</span>
        </v-card-title>

        <v-tabs v-model="activeTab" class="mb-4">
          <v-tab>แพ็คค่าคอมมิชชั่น</v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab">
          <!-- Commission Packs Tab -->
          <v-tab-item>
            <v-row>
              <v-col cols="12" class="d-flex justify-end mb-4">
                <v-btn
                  color="#3b82f6"
                  dark
                  class="create-btn elevation-0"
                  @click="openCreatePackModal"
                >
                  <v-icon left size="24">mdi-plus</v-icon>
                  สร้างแพ็คใหม่
                </v-btn>
              </v-col>

              <v-col cols="12">
                <v-card elevation="0" class="pa-4" style="background: #f8f9fa">
                  <div class="d-flex align-center mb-4">
                    <v-icon color="#3b82f6" class="mr-2">mdi-information-outline</v-icon>
                    <span class="info-text">
                      แพ็คค่าคอมมิชชั่นกำหนดจำนวนขั้นการรับค่าคอมมิชชั่นและเปอร์เซ็นต์ในแต่ละขั้น เมื่อสมาชิกที่ถูกแนะนำมีการใช้จ่าย ผู้แนะนำในแต่ละขั้นจะได้รับค่าคอมมิชชั่นตามที่กำหนด
                    </span>
                  </div>

                  <v-data-table
                    v-if="commissionPacks.length > 0"
                    :headers="packHeaders"
                    :items="commissionPacks"
                    :items-per-page="10"
                    class="elevation-0"
                    hide-default-footer
                  >
                    <template v-slot:[`item.name`]="{ item }">
                      <div class="d-flex align-center">
                        <span class="font-weight-bold">{{ item.name }}</span>
                        <v-chip
                          v-if="item.isActive"
                          small
                          color="success"
                          class="ml-2"
                        >
                          ใช้งานอยู่
                        </v-chip>
                      </div>
                    </template>

                    <template v-slot:[`item.levels`]="{ item }">
                      <div class="d-flex flex-wrap gap-1">
                        <v-chip
                          v-for="(level, idx) in item.levels"
                          :key="idx"
                          small
                          color="primary"
                          outlined
                          class="ma-1"
                        >
                          ขั้นที่ {{ level.level }}: {{ level.percentage }}%
                        </v-chip>
                      </div>
                    </template>

                    <template v-slot:[`item.totalLevels`]="{ item }">
                      <span class="font-weight-bold">{{ item.levels.length }} ขั้น</span>
                    </template>

                    <template v-slot:[`item.totalPercentage`]="{ item }">
                      <span class="font-weight-bold text-primary">
                        {{ getTotalPercentage(item) }}%
                      </span>
                    </template>

                    <template v-slot:[`item.description`]="{ item }">
                      <span class="text-caption grey--text">
                        {{ item.description || "-" }}
                      </span>
                    </template>

                    <template v-slot:[`item.actions`]="{ item, index }">
                      <div class="d-flex">
                        <!-- <v-btn
                          v-if="!item.isActive"
                          icon
                          small
                          color="success"
                          @click="activatePack(item, index)"
                          title="เปิดใช้งานแพ็คนี้"
                        >
                          <v-icon small>mdi-check-circle</v-icon>
                        </v-btn> -->
                        <v-btn
                          icon
                          small
                          color="primary"
                          @click="openEditPackModal(item, index)"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          small
                          color="error"
                          
                          @click="confirmDeletePack(item, index)"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </template>
                  </v-data-table>

                  <div v-else class="text-center py-8">
                    <v-icon size="64" color="grey lighten-1">mdi-package-variant</v-icon>
                    <p class="mt-4 grey--text">ยังไม่มีแพ็คค่าคอมมิชชั่น</p>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>


        </v-tabs-items>
      </v-card>

      <!-- Pack Dialog -->
      <v-dialog v-model="packDialog" max-width="700" persistent>
        <v-card>
          <v-card-title class="dialog-title">
            {{ editedPackIndex === -1 ? 'สร้างแพ็คค่าคอมมิชชั่นใหม่' : 'แก้ไขแพ็คค่าคอมมิชชั่น' }}
          </v-card-title>

          <v-card-text>
            <v-form ref="packForm">
              <v-text-field
                v-model="packForm.name"
                label="ชื่อแพ็ค"
                outlined
                dense
                required
                hint="ชื่อแพ็คค่าคอมมิชชั่น (เช่น แพ็คเริ่มต้น, แพ็คพรีเมียม)"
                persistent-hint
                :rules="[v => !!v || 'กรุณากรอกชื่อแพ็ค']"
                class="mb-4"
              ></v-text-field>

              <v-textarea
                v-model="packForm.description"
                label="คำอธิบาย"
                outlined
                dense
                rows="2"
                hint="อธิบายรายละเอียดของแพ็คนี้"
                persistent-hint
                class="mb-4"
              ></v-textarea>

              <v-divider class="mb-4"></v-divider>

              <div class="d-flex align-center justify-space-between mb-4">
                <span class="section-title">ขั้นค่าคอมมิชชั่น</span>
                <v-btn
                  small
                  color="primary"
                  outlined
                  @click="addLevel"
                  :disabled="packForm.levels.length >= 10"
                >
                  <v-icon left small>mdi-plus</v-icon>
                  เพิ่มขั้น
                </v-btn>
              </div>

              <div class="levels-container">
                <v-card
                  v-for="(level, index) in packForm.levels"
                  :key="index"
                  outlined
                  class="pa-3 mb-3 level-card"
                >
                  <div class="d-flex align-center">
                    <div class="level-number mr-3">
                      <v-avatar color="primary" size="32">
                        <span class="white--text font-weight-bold">{{ index + 1 }}</span>
                      </v-avatar>
                    </div>
                    
                    <v-text-field
                      v-model.number="level.percentage"
                      label="เปอร์เซ็นต์ (%)"
                      type="number"
                      outlined
                      dense
                      hide-details
                      :rules="[
                        v => v !== '' && v !== null || 'กรุณากรอกเปอร์เซ็นต์',
                        v => (v >= 0 && v <= 100) || 'ต้องอยู่ระหว่าง 0-100'
                      ]"
                      class="mr-3"
                      style="max-width: 150px"
                    ></v-text-field>

                    <v-text-field
                      v-model="level.description"
                      label="คำอธิบาย (ไม่บังคับ)"
                      outlined
                      dense
                      hide-details
                      class="mr-3"
                    ></v-text-field>

                    <v-btn
                      icon
                      small
                      color="error"
                      @click="removeLevel(index)"
                      :disabled="packForm.levels.length <= 1"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-card>
              </div>

              <v-alert
                v-if="packForm.levels.length > 0"
                type="info"
                dense
                outlined
                class="mt-4"
              >
                <div class="d-flex justify-space-between">
                  <span>รวมค่าคอมมิชชั่นทั้งหมด:</span>
                  <span class="font-weight-bold">{{ calculateTotalPercentage }}%</span>
                </div>
              </v-alert>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closePackDialog">ยกเลิก</v-btn>
            <v-btn color="primary" @click="savePack">บันทึก</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import swalAlert from "@/services/alert/swalServices";
import { createCommissionPackApi, getCommissionPacksApi, updateCommissionPackApi } from "@/services/api/commissionServices";

export default {
  name: "AdminCommissions",

  data() {
    return {
      isLoading: false,
      activeTab: 0,
      commissionPacks: [],
      paymentsLoading: false,
      
      packDialog: false,
      editedPackIndex: -1,
      packForm: {
        name: "",
        description: "",
        levels: [
          { level: 1, percentage: 0, description: "" },
        ],
      },



      packHeaders: [
        { text: "ชื่อแพ็ค", value: "name", sortable: false },
        { text: "จำนวนขั้น", value: "totalLevels", sortable: false },
        { text: "รวมค่าคอมมิชชั่น", value: "totalPercentage", sortable: false },
        { text: "รายละเอียดขั้น", value: "levels", sortable: false },
        { text: "คำอธิบาย", value: "description", sortable: false },
        { text: "จัดการ", value: "actions", sortable: false, width: "150px" },
      ],


    };
  },

  created() {
    this.fetchCommissionPacks();

  },

  computed: {


    calculateTotalPercentage() {
      return this.packForm.levels.reduce((sum, level) => sum + (Number(level.percentage) || 0), 0);
    },
  },

  methods: {
    async fetchCommissionPacks() {
      this.isLoading = true;
      try {
        const res = await getCommissionPacksApi();
        console.log(res);
        if (res && res.commissions) {
          this.commissionPacks = res.commissions.map(pack => ({
            id: pack.id,
            name: pack.name,
            description: pack.description || "",
            levels: pack.tiers?.map(tier => ({
              level: tier.tierLevel,
              percentage: tier.rate,
              description: tier.tierName || "",
            })) || [],
            isActive: pack.isActive || false,
            createdAt: pack.createdAt || new Date().toISOString(),
          }));
        }
      } catch (error) {
        console.error("Error fetching commission packs:", error);
        swalAlert.Error("โหลดข้อมูลแพ็คค่าคอมมิชชั่นล้มเหลว");
      } finally {
        this.isLoading = false;
      }
    },



    getTotalPercentage(pack) {
      return pack.levels.reduce((sum, level) => sum + (level.percentage || 0), 0);
    },

    openCreatePackModal() {
      this.editedPackIndex = -1;
      this.packForm = {
        name: "",
        description: "",
        levels: [
          { level: 1, percentage: 0, description: "" },
        ],
      };
      this.packDialog = true;
    },

    openEditPackModal(pack, index) {
      this.editedPackIndex = index;
      this.packForm = {
        name: pack.name || "",
        description: pack.description || "",
        levels: pack.levels.map(l => ({ ...l })),
      };
      this.packDialog = true;
    },

    closePackDialog() {
      this.packDialog = false;
      this.editedPackIndex = -1;
      this.packForm = {
        name: "",
        description: "",
        levels: [
          { level: 1, percentage: 0, description: "" },
        ],
      };
      if (this.$refs.packForm) {
        this.$refs.packForm.resetValidation();
      }
    },

    addLevel() {
      const nextLevel = this.packForm.levels.length + 1;
      this.packForm.levels.push({
        level: nextLevel,
        percentage: 0,
        description: "",
      });
    },

    removeLevel(index) {
      this.packForm.levels.splice(index, 1);
      // Reorder levels
      this.packForm.levels.forEach((level, idx) => {
        level.level = idx + 1;
      });
    },

    async savePack() {
      if (!this.$refs.packForm.validate()) {
        return;
      }

      // Validate levels
      const hasInvalidLevel = this.packForm.levels.some(
        level => level.percentage < 0 || level.percentage > 100
      );
      if (hasInvalidLevel) {
        swalAlert.Error("เปอร์เซ็นต์ต้องอยู่ระหว่าง 0-100");
        return;
      }

      this.isLoading = true;

      try {
        if (this.editedPackIndex === -1) {
          // Create new pack - POST /api/v1/commission/create
          const payload = {
            name: this.packForm.name,
            description: this.packForm.description || "",
            tiers: this.packForm.levels.map((level, idx) => ({
              tierLevel: idx + 1,
              tierName: level.description || `ขั้นที่ ${idx + 1}`,
              rate: Number(level.percentage) || 0,
            })),
          };

          const res = await createCommissionPackApi(payload);

          if (res) {
            const newPack = {
              id: res.id || Date.now().toString(),
              name: this.packForm.name,
              description: this.packForm.description || "",
              levels: this.packForm.levels.map((level, idx) => ({
                level: idx + 1,
                percentage: Number(level.percentage) || 0,
                description: level.description || "",
              })),
              isActive: this.commissionPacks.length === 0,
              createdAt: new Date().toISOString(),
            };
            this.commissionPacks.push(newPack);
            swalAlert.Success("สร้างแพ็คสำเร็จ");
          }
        } else {
          // Update existing pack - PUT /api/v1/commission/update/:id
          const pack = this.commissionPacks[this.editedPackIndex];
          const payload = {
            id: pack.id,
            name: this.packForm.name,
            description: this.packForm.description || "",
            tiers: this.packForm.levels.map((level, idx) => ({
              tierLevel: idx + 1,
              tierName: level.description || `ขั้นที่ ${idx + 1}`,
              rate: Number(level.percentage) || 0,
            })),
          };

          await updateCommissionPackApi( payload);

          // Update local state
          Object.assign(pack, {
            name: this.packForm.name,
            description: this.packForm.description || "",
            levels: this.packForm.levels.map((level, idx) => ({
              level: idx + 1,
              percentage: Number(level.percentage) || 0,
              description: level.description || "",
            })),
          });
          swalAlert.Success("อัปเดตแพ็คสำเร็จ");
        }

        this.closePackDialog();
      } catch (error) {
        console.error("Error saving pack:", error);
        swalAlert.Error("บันทึกข้อมูลล้มเหลว");
      } finally {
        this.isLoading = false;
      }
    },

    async confirmDeletePack(pack, index) {
      if (pack.isActive) {
        swalAlert.Error("ไม่สามารถลบแพ็คที่กำลังใช้งานอยู่ได้");
        return;
      }

      const result = await swalAlert.Confirm({
        title: "ยืนยันการลบ",
        message: `คุณต้องการลบแพ็ค "${pack.name}" ใช่หรือไม่?`
      });

      if (result.isConfirmed) {
        this.isLoading = true;
        // Simulate API delay
        await new Promise(resolve => setTimeout(resolve, 500));

        try {
          this.commissionPacks.splice(index, 1);
          swalAlert.Success("ลบแพ็คสำเร็จ");
        } catch (error) {
          console.error("Error deleting pack:", error);
          swalAlert.Error("ลบแพ็คล้มเหลว");
        } finally {
          this.isLoading = false;
        }
      }
    },

    async activatePack(pack, index) {
      const result = await swalAlert.Confirm({
        title: "ยืนยันการเปิดใช้งาน",
        message: `คุณต้องการเปิดใช้งานแพ็ค "${pack.name}" ใช่หรือไม่?\n\nแพ็คที่ใช้งานอยู่ปัจจุบันจะถูกปิดใช้งาน`
      });

      if (result.isConfirmed) {
        this.isLoading = true;
        // Simulate API delay
        await new Promise(resolve => setTimeout(resolve, 500));

        try {
          // Deactivate all packs
          this.commissionPacks.forEach(p => {
            p.isActive = false;
          });
          // Activate selected pack
          this.commissionPacks[index].isActive = true;
          swalAlert.Success(`เปิดใช้งานแพ็ค "${pack.name}" สำเร็จ`);
        } catch (error) {
          console.error("Error activating pack:", error);
          swalAlert.Error("เปิดใช้งานแพ็คล้มเหลว");
        } finally {
          this.isLoading = false;
        }
      }
    },



    formatCurrency(amount) {
      if (!amount) return "0.00";
      return new Intl.NumberFormat("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    },



    getStatusColor(status) {
      const colors = {
        pending: "orange",
        paid: "green",
        cancelled: "red",
      };
      return colors[status] || "grey";
    },

    // eslint-disable-next-line no-unused-vars
    getStatusTextColor(_status) {
      return "white";
    },

    getStatusText(status) {
      const texts = {
        pending: "รอการจ่าย",
        paid: "จ่ายแล้ว",
        cancelled: "ยกเลิก",
      };
      return texts[status] || status;
    },
  },
};
</script>

<style scoped>
/* Base font for entire component */
.v-container {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
}

.title-text {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
  font-size: 24px;
  font-weight: 700;
  color: #1f2a39;
}

.dialog-title {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
  font-size: 18px;
  font-weight: 600;
  color: #1f2a39;
}

.section-title {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
  font-size: 16px;
  font-weight: 600;
  color: #1f2a39;
}

.info-text {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
  font-size: 14px;
  font-weight: 400;
  color: #6b7280;
}

.card-container {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
  border-radius: 16px !important;
  box-shadow: 0 0 2px 0 #1018280d !important;
}

/* Tabs */
::v-deep .v-tab {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
  font-weight: 600 !important;
  text-transform: none !important;
}

/* Table */
::v-deep .v-data-table {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
}

::v-deep .v-data-table th {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
  font-weight: 600 !important;
}

::v-deep .v-data-table td {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
}

/* Buttons */
.create-btn {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  height: 40px !important;
  text-transform: none !important;
}

::v-deep .v-btn {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
  text-transform: none !important;
}

/* Form inputs */
::v-deep .v-text-field,
::v-deep .v-textarea,
::v-deep .v-select {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
}

::v-deep .v-label {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
}

::v-deep .v-messages {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
}

/* Chips */
::v-deep .v-chip {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
}

/* Alerts */
::v-deep .v-alert {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
}

/* Dialog */
::v-deep .v-dialog {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
}

::v-deep .v-card-title {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
}

::v-deep .v-card-text {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
}

::v-deep .v-card-actions {
  font-family: 'Sarabun', 'Noto Sans Thai', sans-serif !important;
}

.levels-container {
  max-height: 400px;
  overflow-y: auto;
}

.level-card {
  transition: all 0.2s ease;
  border-color: #e0e0e0 !important;
}

.level-card:hover {
  border-color: #3b82f6 !important;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15);
}

.gap-1 {
  gap: 4px;
}

@media (max-width: 960px) {
  .create-btn {
    width: 100% !important;
  }

  .level-card .d-flex {
    flex-wrap: wrap;
  }

  .level-card .v-text-field {
    max-width: 100% !important;
    margin-bottom: 8px;
  }
}
</style>
